import { createFileRoute, Navigate } from "@tanstack/react-router"
import { useAuthEmployeeQuery } from "modules/auth/hooks/useAuthEmployeeQuery"
import { ReferralsPage } from "modules/referrals/components/ReferralsPage"
import { Loading } from "modules/shared/components/Loading"
import { useSubscriptionData } from "modules/subscription/hooks/useSubscriptionData"
import { canSeeReferrals } from "modules/subscription/lib/canSeeReferrals"

export const Route = createFileRoute("/_base/_auth/settings/subscription/referrals")({
  component: RouteComponent,
})

function RouteComponent() {
  const { data: employee } = useAuthEmployeeQuery()
  const { isPending, activeSubscriptionName } = useSubscriptionData()

  if (!employee || isPending) {
    return <Loading />
  }

  if (!canSeeReferrals(employee, activeSubscriptionName)) {
    return <Navigate to="/settings/subscription/usage" replace />
  }

  return <ReferralsPage />
}
